<!-- <pre>snapshotParams: {{ snapshotParams|json }}</pre>-->
<app-fullscreen-loader *ngIf="isLoading | async" />

<ng-container *ngIf="detailHeaderSubject | async as detailHeader">
  <app-card-reject-reason
    *ngIf="snapshotParams.status !== DistributorTabStatus.PENDING && hasRejectReason()"
    [loading]="isLoading"
    [bodyList]="rejectReason"
    [useListDesc]="true"
    [title]="getRejectReasonTitleCard()"
  />

  <app-card
    *ngIf="detailHeader.note_reject_non_active"
    [borderHeader]="true"
    [border]="true"
    [cardClasses]="'mb-7 card-reject-reason'"
    [cardHeaderTitle]="'Catatan Perbaikan Penonaktifan Distributor'"
    [header]="true"
  >
    <ng-container cardBody>
      <ul>
        <li>{{ detailHeader.note_reject_non_active }}</li>
      </ul>
    </ng-container>
  </app-card>

  <app-card
    *ngIf="detailHeader.non_active_reason && detailHeader.non_active_reason.length > 0"
    [borderHeader]="true"
    [border]="true"
    [cardClasses]="'mb-7'"
    [cardHeaderTitle]="'Alasan Penonaktifan Distributor'"
    [header]="true"
  >
    <ng-container cardBody>
      <ul>
        <li *ngFor="let value of detailHeader.non_active_reason">{{ value }}</li>
      </ul>
    </ng-container>
  </app-card>

  <app-note-view *ngIf="detailHeader.receivable_reason" [text]="detailHeader.receivable_reason" [color]="'info'" [icon]="STRING_CONSTANTS.ICON.IC_INFORMATION"></app-note-view>

  <app-card-profile-header [isLoading]="isLoading" [labelList]="detailCardHeaderLabelList" [name]="detailHeader.business_name" [status]="getProfileHeaderStatus()" />
</ng-container>

<ng-container *ngIf="isDistributorParamStatus(DistributorTabStatus.REGISTERED)">
  <app-detail-teregistrasi-active />
</ng-container>

<ng-container *ngIf="isDistributorParamStatus(DistributorTabStatus.REJECT)">
  <app-detail-reject />
</ng-container>

<!-- detail distributor sedang menunggu -->
<ng-container *ngIf="isDistributorParamStatus(DistributorTabStatus.PENDING)">
  <app-detail-registration *ngIf="isDistributorParamTab(DistributorStatusEnumTabString.REGISTRATION)" [detailHeaderSubject]="detailHeaderSubject" />

  <app-detail-verification *ngIf="isDistributorParamTab(DistributorStatusEnumTabString.VERIFICATION)" [detailHeaderSubject]="detailHeaderSubject" />

  <app-detail-edit-request *ngIf="isDistributorParamTab(DistributorStatusEnumTabString.EDIT_REQUEST)" [detailHeaderSubject]="detailHeaderSubject" />

  <app-detail-non-active *ngIf="isDistributorParamTab(DistributorStatusEnumTabString.NON_ACTIVE)" [detailHeaderSubject]="detailHeaderSubject" />
</ng-container>

<!-- detail distributor log view -->
<app-detail-distributor-log [detailHeaderSubject]="detailHeaderSubject" *ngIf="isDistributorParamTab(DistributorStatusEnumTabString.LOG)" />
